import React from 'react';
import styles from './LinkAccountPanel.module.css'; 

function LinkAccountPanel({ onSocialLogin }) {
  return (
    <>
      <div className={styles.account_link_header}>
        <div className={`innocode-typography--title-lg innocode-typography--bold ${styles.account_link_title}`}>
          계정을 연동해 보다 쉽게
          <br className={styles.mobile_only} /> 로그인하세요!
        </div>
        <div className={`innocode-typography--body-md-reading innocode-typography--regular ${styles.account_link_description}`}>
          간편로그인으로 계정을 연동해 두면
          <br className={styles.mobile_only} /> 빠르게 로그인 할 수 있어요!
        </div>
      </div>
      <div className={styles.account_link_content}>
        <div className={styles.account_link_buttons}>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_kakao}`}
            onClick={() => onSocialLogin('kakao')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/vector-kakao.svg" alt="kakao-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_kakao}`}>
              카카오 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_naver}`}
            onClick={() => onSocialLogin('naver')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/vector-naver.svg" alt="naver-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_naver}`}>
              네이버 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_google}`}
            onClick={() => onSocialLogin('google')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/vector-google.svg" alt="google-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_google}`}>
              구글 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_apple}`}
            onClick={() => onSocialLogin('apple')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/vector-apple.svg" alt="apple-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_apple}`}>
              Apple 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_facebook}`}
            onClick={() => onSocialLogin('facebook')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/Facebook_Logo.png" alt="apple-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_facebook}`}>
              Facebook 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_spotify}`}
            onClick={() => onSocialLogin('spotify')}
          >
            <div className={styles.social_login_icon}>
              <img src="/assets/Spotify_Primary_Logo_RGB_White.png" alt="apple-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_spotify}`}>
              Spotify 로그인
            </div>
          </button>
          <button
            type="button"
            className={`${styles.social_login_btn} ${styles.social_login_btn_twitter}`}
            onClick={() => onSocialLogin('twitter')}
          >
            <div className={`${styles.social_login_icon} ${styles.twitter_img}`}>  
              <img src="/assets/twttier-logo-white.png" alt="apple-login" />
            </div>
            <div className={`${styles.social_login_text} ${styles.social_login_text_twitter}`}>
              Twitter 로그인
            </div>
          </button>
        </div>
      </div>
    </>
  );
}

export default LinkAccountPanel;
